import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { useVehicleLookup } from '@motorway/motorway-handshake-components';

export const DatadogVehicle = () => {
  const { vehicle } = useVehicleLookup();

  useEffect(() => {
    if (!vehicle?.enquiry) {
      return;
    }

    const { enquiry } = vehicle;
    const { closingBid, id, vehicle: vehicleData, vehicleDetails } = enquiry;
    const { vrm, prettyVrm } = vehicleDetails;

    const isProd = globalThis.location.hostname === 'driver.motorway.co.uk';
    const dashboard = isProd ? '' : 'stage.';

    const DD_CONTEXT = {
      ...vehicleData,
      bid: closingBid?.value,
      dashboard: `https://${dashboard}dashboard.motorway.co.uk/vehicles/${id}`,
      prettyVrm,
      vrm,
    };

    datadogLogs.setGlobalContextProperty('vehicle', DD_CONTEXT);
    datadogRum.setGlobalContextProperty('vehicle', DD_CONTEXT);
  }, [vehicle]);

  return null;
};
